import datetime from '@sayyesschool/common/libs/datetime';
import ConfirmButton from '@sayyesschool/frontend/components/confirm-button';
import { Flex, IconButton, Switch, Table } from '@sayyesschool/frontend/ui-components';

const columns = [
    { key: 'visits', content: 'Кол-во посещений' },
    { key: 'price', content: 'Стоимость, руб.' },
    { key: 'priceWithoutDiscount', content: 'Стоимость без скидки, руб.' },
    { key: 'duration', content: 'Длительность' },
    { key: 'actions' }
];

export default function MembershipPacksTable({
    packs,
    onEdit,
    onToggle,
    onDelete
}) {
    return (
        <Table className="MembershipPacksTable">
            <Table.Head>
                <Table.Row header>
                    {columns.map(column =>
                        <Table.Cell
                            key={column.key}
                            content={column.content}
                            header
                        />
                    )}
                </Table.Row>
            </Table.Head>

            <Table.Body>
                {packs.map((pack, index) =>
                    <Table.Row key={pack.id}>
                        <Table.Cell content={pack.visits} />
                        <Table.Cell content={pack.price} />
                        <Table.Cell content={pack.priceWithoutDiscount} />
                        <Table.Cell content={datetime.duration(pack.duration[0], pack.duration[1]).humanize()} />

                        <Table.Cell align="end">
                            <Flex
                                align="center"
                                justify="flex-end"
                                gap="xs"
                            >
                                <Switch
                                    title={pack.active ? 'Активен' : 'Не активен'}
                                    checked={pack.active}
                                    onClick={() => onToggle(pack)}
                                />

                                <IconButton.Group>
                                    <IconButton
                                        title="Изменить"
                                        icon="edit"
                                        size="sm"
                                        onClick={() => onEdit(pack)}
                                    />

                                    <ConfirmButton
                                        title="Удалить"
                                        message="Удалить пакет?"
                                        icon="delete"
                                        color="danger"
                                        size="sm"
                                        onConfirm={() => onDelete(pack)}
                                    />
                                </IconButton.Group>
                            </Flex>
                        </Table.Cell>
                    </Table.Row>
                )}
            </Table.Body>
        </Table>
    );
}